import { getDefaultBanner } from './helpers';
import { DIMENSIONS } from '../constants/dimensions';

const GAMConstants = {
  MOVE: 'move',
  CONTENT: 'content',
  ALP: 'alp'
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const getGAMConfigData = ({ experienceSlug, channel }) => {
  switch (experienceSlug) {
  case GAMConstants.MOVE:
    return {
      label: `${experienceSlug}-${channel}`,
      adUnitPath: `/22299932394/Movers-Non-Endemic-Native-${capitalizeFirstLetter(channel)}`,
      maxBannerDimensions: channel === 'mobile'
        ? [DIMENSIONS.GAM.MOVE.WIDTH.MOBILE,
          DIMENSIONS.GAM.MOVE.HEIGHT.MOBILE]
        : [DIMENSIONS.GAM.MOVE.WIDTH.DESKTOP,
          DIMENSIONS.GAM.MOVE.HEIGHT.DESKTOP],
      adAssetDimensions: ['fluid'],
      css: { }
    };
  case GAMConstants.ALP:
  case GAMConstants.CONTENT:
    return {
      label: `${experienceSlug}-${channel}`,
      adUnitPath: `/22299932394/DIY-Landing-${capitalizeFirstLetter(channel)}`,
      maxBannerDimensions: channel === 'mobile'
        ? [DIMENSIONS.GAM.DIY.WIDTH.MOBILE,
          DIMENSIONS.GAM.DIY.HEIGHT.MOBILE]
        : [DIMENSIONS.GAM.DIY.WIDTH.DESKTOP,
          DIMENSIONS.GAM.DIY.HEIGHT.DESKTOP],
      adAssetDimensions: ['fluid'],
      css: { margin: '0px auto', overflow: 'hidden' }
    };
  default:
    return {
      label: `default-${channel}`,
      adUnitPath: '/6075/gvarelal_dfptest/gvarelal_trainingseries',
      maxBannerDimensions: [DIMENSIONS.GAM.DEFAULT.WIDTH, DIMENSIONS.GAM.DEFAULT.HEIGHT],
      adAssetDimensions: [DIMENSIONS.GAM.DEFAULT.WIDTH, DIMENSIONS.GAM.DEFAULT.HEIGHT],
      css: { }
    };
  }
};

const getExperienceStyledDefaultBanner = (experienceContext, gamConfigData) => {
  let standardDefaultBanner = getDefaultBanner(experienceContext);
  const { maxBannerDimensions, css = {} } = gamConfigData;
  const containerStyle = {
    maxWidth: `${maxBannerDimensions[0]}px`,
    height: `${maxBannerDimensions[1]}px`,
    ...css
  };
  standardDefaultBanner = { ...standardDefaultBanner, containerStyle };
  standardDefaultBanner.bgCss.maxWidth = `${maxBannerDimensions[0]}px`;
  standardDefaultBanner.bgCss.height = `${maxBannerDimensions[1]}px`;

  return standardDefaultBanner;
};

function addScriptTag(url) {
  if (!window.googletag) {
    const gamScript = document.createElement('script');
    gamScript.async = true;
    gamScript.src = url;

    const firstScript = document.getElementsByTagName('body')[0];
    firstScript.parentNode.insertBefore(gamScript, firstScript);
  }
}

export { addScriptTag, getGAMConfigData, getExperienceStyledDefaultBanner, GAMConstants };
